module.exports = __webpack_public_path__ + "static/media/pancreas.d242e7c7.svg";